import { authenticationReducerActions } from "../../../_services/store";
import { navigationConstants } from "../../../_services/store/navigation.constants";
import { setupService } from "../setup.service";
import { userService } from "../user.service";
import { setupConstants } from "./setup.constants";

export const setupActions = {
    determineShopifyPaymentProviders,
    getSetupStatus,
    deleteAccount,
    prepareShopifyBillingActivation,
    prepareShopifyBillingActivationForClient,
    activateCharge,
    activateChargeForClient,
};

function determineShopifyPaymentProviders(externalUUID) {
    return (dispatch) => {
        dispatch(request());

        return setupService.determineShopifyPaymentProviders(externalUUID).then(
            (result) => {
                dispatch(success(result));
                return result;
            },
            (error) => {
                dispatch(failure(error));
                return Promise.reject(error);
            }
        );
    };

    function request() {
        return { type: setupConstants.DETERMINE_SHOPIFY_PAYMENT_PROVIDERS_REQUEST };
    }

    function success(result) {
        return {
            type: setupConstants.DETERMINE_SHOPIFY_PAYMENT_PROVIDERS_SUCCESS,
            result: result,
        };
    }

    function failure(errorMessage) {
        return {
            type: setupConstants.DETERMINE_SHOPIFY_PAYMENT_PROVIDERS_FAILURE,
            errorMessage,
        };
    }
}

function getSetupStatus() {
    return (dispatch) => {
        dispatch(request());

        return setupService.getSetupStatus().then(
            (result) => {
                userService.reloadUserInStorage().then((user) => {
                    dispatch({
                        type: navigationConstants.UPDATE_NAVIGATION_ITEMS,
                        userRole: user.userRole,
                        allowedApps: user.selectedOrganization.allowedApps,
                        allowedModules: user.selectedOrganization.allowedModules,
                        organizationType: user.selectedOrganization.organizationType,
                    });
                    dispatch(authenticationReducerActions.updateLoggedInUserSuccess(user));
                    dispatch(success(result));
                });

                return result;
            },
            (error) => {
                dispatch(failure(error));
                return Promise.reject(error);
            }
        );
    };

    function request() {
        return { type: setupConstants.GET_SETUP_STATUS_REQUEST };
    }

    function success(result) {
        return { type: setupConstants.GET_SETUP_STATUS_SUCCESS, result: result };
    }

    function failure(errorMessage) {
        return { type: setupConstants.GET_SETUP_STATUS_FAILURE, errorMessage };
    }
}

function deleteAccount() {
    return (dispatch) => {
        dispatch(request());

        return setupService.deleteAccount().then(
            (result) => {
                dispatch(success(result));
                return result;
            },
            (error) => {
                dispatch(failure(error));
                return error;
            }
        );
    };

    function request() {
        return { type: setupConstants.DELETE_APPSTORE_ACCOUNT_REQUEST };
    }

    function success(result) {
        return {
            type: setupConstants.DELETE_APPSTORE_ACCOUNT_SUCCESS,
            result: result,
        };
    }

    function failure(errorMessage) {
        return {
            type: setupConstants.DELETE_APPSTORE_ACCOUNT_FAILURE,
            errorMessage,
        };
    }
}

function prepareShopifyBillingActivation() {
    return (dispatch) => {
        dispatch(request());

        return setupService.prepareBillingActivation().then(
            (result) => {
                dispatch(success(result));
                return result;
            },
            (error) => {
                dispatch(failure(error));
                return Promise.reject(error);
            }
        );
    };

    function request() {
        return { type: setupConstants.ACTIVATE_SHOPIFY_BILLING_REQUEST };
    }

    function success(result) {
        return {
            type: setupConstants.ACTIVATE_SHOPIFY_BILLING_SUCCESS,
            result: result,
        };
    }

    function failure(errorMessage) {
        return {
            type: setupConstants.ACTIVATE_SHOPIFY_BILLING_FAILURE,
            errorMessage,
        };
    }
}

function activateCharge(chargeId) {
    return (dispatch) => {
        dispatch(request());

        return setupService.activateCharge(chargeId).then(
            (result) => {
                dispatch(success(result));
                return result;
            },
            (error) => {
                dispatch(failure(error));
                return error;
            }
        );
    };

    function request() {
        return { type: setupConstants.ACTIVATE_SHOPIFY_BILLING_CHARGE_REQUEST };
    }

    function success(result) {
        return {
            type: setupConstants.ACTIVATE_SHOPIFY_BILLING_CHARGE_SUCCESS,
            result: result,
        };
    }

    function failure(errorMessage) {
        return {
            type: setupConstants.ACTIVATE_SHOPIFY_BILLING_CHARGE_FAILURE,
            errorMessage,
        };
    }
}

function prepareShopifyBillingActivationForClient(clientUUID) {
    return (dispatch) => {
        dispatch(request());

        return setupService.prepareBillingActivationForClient(clientUUID).then(
            (result) => {
                dispatch(success(result));
                return result;
            },
            (error) => {
                dispatch(failure(error));
                return Promise.reject(error);
            }
        );
    };

    function request() {
        return {
            type: setupConstants.PREPARE_SHOPIFY_BILLING_FOR_CLIENT_REQUEST,
            clientUUID: clientUUID,
        };
    }

    function success(result) {
        return {
            type: setupConstants.PREPARE_SHOPIFY_BILLING_FOR_CLIENT_SUCCESS,
            clientUUID: clientUUID,
            result: result,
        };
    }

    function failure(errorMessage) {
        return {
            type: setupConstants.PREPARE_SHOPIFY_BILLING_FOR_CLIENT_FAILURE,
            clientUUID: clientUUID,
            errorMessage: errorMessage,
        };
    }
}

function activateChargeForClient(chargeId, clientUUID) {
    return (dispatch) => {
        dispatch(request());

        return setupService.activateChargeForClient(chargeId, clientUUID).then(
            (result) => {
                dispatch(success(undefined));
                return result;
            },
            (error) => {
                dispatch(failure(error));
                return Promise.reject(error);
            }
        );
    };

    function request() {
        return {
            type: setupConstants.ACTIVATE_SHOPIFY_BILLING_CHARGE_REQUEST,
            clientUUID: clientUUID,
        };
    }

    function success() {
        return {
            type: setupConstants.ACTIVATE_SHOPIFY_BILLING_CHARGE_SUCCESS,
            clientUUID: clientUUID,
        };
    }

    function failure(errorMessage) {
        return {
            type: setupConstants.ACTIVATE_SHOPIFY_BILLING_CHARGE_FAILURE,
            clientUUID: clientUUID,
            errorMessage: errorMessage,
        };
    }
}
